import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import * as AhorroYCreditoActions from "app/@Content/components/AhorroYCredito/store/actions";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Delegado from "./Delegado";
import ValidarDelegado from "./ValidarDelegado";

import "./DelegadoContainer.css";

const DelegadoContainer = ({ ...props }) => {
  const dispatch = useDispatch();
  const [meta, setMeta] = useState({});
  
  const [delegate, setDelegate] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { isValidDelegate } = useSelector(
    ({ Base }) => Base.ContenidoInterconexion
  );

  const { delegados } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    const defRoute = rutas?.filter((route) => route?.name === "Delegados")[0];

    setMeta((m) => {
      return {
        ...m,
        title: defRoute.title,
        description: defRoute.description,
        url: defRoute.url,
      };
    });    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isValidDelegate) {
      dispatch(AhorroYCreditoActions.getCMSDelegados());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidDelegate]);

  useEffect(() => {
    if (!isEmpty(delegados)) {
      setDelegate({
        title: delegados?.aCDelegados[0].titulo,
        description: delegados?.aCDelegados[0].descripcion?.html,
        //   details: res.bag?.contentItems,
        files: delegados?.aCDelegados[0].archivosDescargables?.contentItems,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delegados]);

  return (
    <>
      <Meta
        title={meta?.title}
        description={meta?.description}
        canonicalUrl={meta?.url}
      />
      <Breadcrumbs items={[]} active={meta.title} />
      {isValidDelegate ? (
        !isEmpty(delegate) && <Delegado delegado={delegate} />
      ) : (
        <div className="main-container-delegado">
          <ValidarDelegado />
        </div>
      )}
    </>
  );
};

export default DelegadoContainer;
